// Single source of truth for the cream collection catalog.
// Every product on the cinematic site reads from here.
// Each card redirects to its Shopify product page on click.

export const creamProducts = {
  "embossed-cream-unixorn-set": {
    id: "embossed-cream-unixorn-set",
    name: "UNIXORN Cream Set",
    category: "tracksuits",
    tagline: "The full silhouette. Forged in cream.",
    price: 180,
    image: "/assets/images/cream/cream-set.png",
    description:
      "Hoodie + Sweatpants — the complete UNIXORN cream tracksuit. Engineered in heavyweight cream fleece with the embossed UNIXORN signature carried across both pieces.",
  },
  "cream-hoodie": {
    id: "cream-hoodie",
    name: "Cream Hoodie",
    category: "classics",
    tagline: "Unique & Original. Embossed and quiet.",
    price: 140,
    image: "/assets/images/cream/cream-hoodie.png",
    description:
      "Heavyweight cream hoodie with the UNIXORN signature embossed tonally on the chest. Oversized, sculpted, monochromatic — the foundational piece of the collection.",
  },
  "embossed-cream-unixorn-sweatpants": {
    id: "embossed-cream-unixorn-sweatpants",
    name: "Cream Sweatpants",
    category: "tracksuits",
    tagline: "Forged for movement. Cut for stillness.",
    price: 120,
    image: "/assets/images/cream/cream-sweatpants.png",
    description:
      "Heavyweight cream sweatpants with tonal embossed UNIXORN detail. Tapered silhouette. Built to move, designed to stay.",
  },
  "signature-statement-tee": {
    id: "signature-statement-tee",
    name: "Signature Statement Tee",
    category: "tshirts",
    tagline: "The unicorn as monument.",
    price: 80,
    image: "/assets/images/cream/signature-statement-tee.png",
    description:
      "Oversized cream tee with a sculpted unicorn relief and UNIXORN MMXXV emboss. The statement piece of the collection.",
  },
  "sigil-tee": {
    id: "sigil-tee",
    name: "Sigil Tee",
    category: "tshirts",
    tagline: "The X. The sigil. The mark.",
    price: 90,
    image: "/assets/images/cream/sigil-tee.png",
    description:
      "Oversized cream tee with the UNIXORN cross sigil embossed at chest centre. A symbol carried, never explained.",
  },
  "saint-tee": {
    id: "saint-tee",
    name: "Saint Tee",
    category: "tshirts",
    tagline: "Innocence is power. Purpose is eternal.",
    price: 95,
    image: "/assets/images/cream/saint-tee.png",
    description:
      "Editorial cream tee bearing the Saint of Originality icon. A relic for the forward-walking few.",
  },
  "essentials-tee": {
    id: "essentials-tee",
    name: "Essentials Tee",
    category: "tshirts",
    tagline: "The whisper. The base layer of the relic.",
    price: 75,
    image: "/assets/images/cream/essentials-tee.png",
    description:
      "The foundation. Heavyweight cream tee with the small UNIXORN MMXXV chest mark. Minimal, complete.",
  },
  "unixorn-relic-bucket-hat": {
    id: "unixorn-relic-bucket-hat",
    name: "UNIXORN Relic Bucket Hat",
    category: "crowns",
    tagline: "The crown for the unbothered.",
    price: 48,
    image: "/assets/images/cream/bucket-hat.png",
    description:
      "Structured cream bucket hat with the embroidered UNIXORN sigil. Finished by hand, made to weather every season.",
  },
  "sigil-cap-copy": {
    id: "sigil-cap-copy",
    name: "Cream Sigil Beanie",
    category: "crowns",
    tagline: "Quiet warmth. Forged identity.",
    price: 55,
    image: "/assets/images/cream/beanie.png",
    description:
      "Ribbed cream beanie with the embroidered UNIXORN sigil. Heavyweight knit, soft hand, made for the cold seasons.",
  },
};

// Convenience filtered lists
export const productsByCategory = (cat) =>
  Object.values(creamProducts).filter((p) => p.category === cat);

export const featuredProducts = [
  creamProducts["embossed-cream-unixorn-set"],
  creamProducts["cream-hoodie"],
  creamProducts["saint-tee"],
];
